import { presentationsCreateCommand } from './presentations_create';

export const PRESENTATIONS_COMMANDS = [
    presentationsCreateCommand
];

export { presentationsCreateCommand };

